<template>
  <!-- Komponent odpowiedzialny za wybór typu wykresu (np. liniowy, słupkowy) -->
  <div class="graph-type">
    <!-- Nagłówek sekcji (typ wykresu) -->
    <h3 class="margin-0">{{ t('chart-type').toUpperCase() }}</h3>
    <!-- Select do wyboru typu wykresu, powiązany z filtrem w store -->
    <select class="form-select" name="graphType" v-model.lazy="value">
      <!-- Lista opcji do wyboru generowana dynamicznie na podstawie store.graphType -->
      <option
        v-for="(option, index) in store.graphType"
        :key="index"
        :value="index"
      >
        <!-- Tłumaczenie nazwy opcji, np. "Liniowy", "Słupkowy" -->
        {{ t(option) }}
      </option>
    </select>
  </div>
</template>

<script>
import { watch, ref } from "vue";

export default {
  // Oczekiwany obiekt store z filtrami (przekazany przez rodzica)
  props: {
    store: { required: true },
  },
  name: "GrapfTypeFilter", // (uwaga, literówka: powinno być GraphTypeFilter)
  setup(props) {
    // Reaktywna wartość powiązana z wybranym typem wykresu
    const value = ref(props.store.filters.graphType);

    // Funkcja zapisująca zmianę wartości do store
    const saveValue = (text) => {
      props.store.addItem("graphType", text);
    };

    // Reaguj na zmianę value i aktualizuj store
    watch(value, (newValue) => {
      saveValue(newValue); // wywołanie przy każdej zmianie selecta
    });

    return { value };
  },
};
</script>
<style scoped>
.graph-type {
  width: 50%;
  min-height: 140px;
  /* Opcjonalne tło, jeśli potrzebujesz graficznego podziału sekcji */
  /* background: #f5f4f2 url("../../assets/a-filter-bg.png") repeat-x left top; */
}
.graph-type h3 {
  /* Wygląd nagłówka sekcji */
  /* margin: 0; */
  padding: 10px 15px 5px;
  width: 100%;
  border-right: 1px solid #e1e1df;
}
.graph-type select {
  /* Styl selecta */
  height: 30px;
  margin-top: 6px;
  font-size: 12px;
}
</style>
